<script lang="ts">
  import { onMount } from "svelte";
  import { toast } from "@zerodevx/svelte-toast";
  import FeatureTypeOne from "../components/FeatureTypeOne.svelte";

  let allElementsToAnimate;

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const scrollToRegisterInterest = () => {
    document.getElementById("register_interest").scrollIntoView();
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  function encode(data) {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&");
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    const emailAddress = (<HTMLInputElement>(
      document.getElementById("email_address")
    )).value;

    if (!validateEmail(emailAddress)) {
      toast.push("Please enter valid email", {
        theme: {
          "--toastBackground": "#AA0000",
          "--toastBarBackground": "#770000",
        },
      });
      return;
    }

    const myForm: any = document.getElementById("form_logmypoop_notify");
    const emailValue = document.getElementById(
      "email_address"
    ) as HTMLInputElement | null;
    fetch("/", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: encode({
        "form-name": "logmypoop_register",
        "email_address": emailValue?.value,
      }),
    })
      .then(() => {
        toast.push("Thanks. We will notify you.", {
          theme: {
            "--toastBackground": "#48BB78",
            "--toastBarBackground": "#2F855A",
          },
        });
        myForm.reset();
      })
      .catch((error) => alert(error));
  };

  const handleFeedbackSubmit = (e) => {
    e.preventDefault();

    const feedback_email_address = (<HTMLInputElement>(
      document.getElementById("feedback_email_address")
    )).value;

    const commentText = (<HTMLTextAreaElement>(
      document.getElementById("comment")
    )).value;

    if (!validateEmail(feedback_email_address)) {
      toast.push("We need a valid email so that we can respond to your comment.", {
        theme: {
          "--toastBackground": "#AA0000",
          "--toastBarBackground": "#770000",
        },
      });
      return;
    }

    if (commentText?.trim().length<5) {
      toast.push("Please provide some useful comment", {
        theme: {
          "--toastBackground": "#AA0000",
          "--toastBarBackground": "#770000",
        },
      });
      return; 
    }

    const feedBackForm: any = document.getElementById("form_logmypoop_feedback");
    const emailValue = document.getElementById(
      "feedback_email_address"
    ) as HTMLInputElement | null;
    const commentValue = document.getElementById(
      "comment"
    ) as HTMLTextAreaElement | null;
    const commentType = document.getElementById(
      "commenttype"
    ) as HTMLSelectElement | null;
    
    fetch("/", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: encode({
        "form-name": "form_logmypoop_feedback",
        "email_address": emailValue?.value,
        "comment": commentValue?.value.trim(),
        "commenttype": commentType?.value,
      }),
    })
      .then(() => {
        toast.push("Thank you for your comment. We will review it.", {
          theme: {
            "--toastBackground": "#48BB78",
            "--toastBarBackground": "#2F855A",
          },
        });
        feedBackForm.reset();
      })
      .catch((error) => alert(error));
  };

  // Callback for IntersectionObserver
  const callback = function (entries) {
    entries.forEach((entry) => {
      const animationType = entry.target.dataset.animateType;

      // Is the element in the viewport?
      if (entry.isIntersecting) {
        // Add the fadeIn class:
        entry.target.classList.add(animationType);
      } else {
        // Otherwise remove the fadein class
        entry.target.classList.remove(animationType);
        entry.target.classList.remove("opacity-0");
      }
    });
  };

  onMount(() => {
    allElementsToAnimate = document.querySelectorAll("[data-animate-type]");
    // Set up a new observer
    const observer = new IntersectionObserver(callback);
    // Loop through each of the target
    allElementsToAnimate.forEach(function (target) {
      // Hide the element
      target.classList.add("opacity-0");
      // Add the element to the watcher
      observer.observe(target);
    });
  });
</script>

<svelte:head>
  <title>LogMyPoop | Log My Poop | Poop Log | Digestive Wellness App</title>
  <link rel="icon" type="image/png" href="images/favicon.png" />
  <meta name="viewport" content="width=device-width, initial-scale=1,user-scalable=0">
  <meta name="title" content="LogMyPoop or Log My Poop or Poop Log , Bowel, Gut and Digestive Health Tracking App Landing Page">
<meta name="description" content="Free Bowel Health Tracking iOS and Android App. This app helps for constipation relief,Irritable bowel syndrome (IBS) and provides Digestive support.">
<meta name="keywords" content="Bowel Health, Digestive wellness, Gut health, Intestinal health, 
Poop Log, Poop Diary, Log Poop, Digestive support, Probiotics for digestive health,Digestive enzymes,Gastrointestinal health
Constipation relief,Fiber for digestive health,Irritable bowel syndrome (IBS),Log My Poop, LogMyPoop, Squaredojo, Free Health App, Free App, Bristol Chart, Bristol Stool, Constipation">
<meta name="robots" content="index, follow">
<meta lang="english" content="text/html; charset=utf-8">
<meta name="language" content="English">
<meta name="revisit-after" content="30 days">
<meta name="author" content="Squaredojo">
<meta property="og:title" content={"Log My Poop - Free Digestive Health App"}>
<meta property="og:site_name" content={"Log My Poop LogMyPoop"}>
<meta property="og:url" content=https://squaredojo.com/#/logmypoop>
<meta property="og:description" content={"LogMyPoop or Log My Poop , Bowel, Gut and Digestive Health Tracking App. The free app can log your poop, link medicines, relate habits and note down symptoms too. This gives you smart insight into your gut health and provides digestive wellness."}>
<meta property="og:type" content=product>
<meta property="og:image" content=https://www.squaredojo.com/images/logmypoop/log-my-poop-hero-image.png>
</svelte:head>
<!-- nav -->
<nav class="flex bg-purple-50">
  <a href="/#/logmypoop" class="p-2 w-1/2">
    <img
      src="../images/logmypoop/favicon.png"
      width="42"
      alt="LogMyPoop logo"
    />
  </a>
  <h5 class="font-black text-purple-900 text-2xl text-center pt-1 w-1/2">
    LogMyPoop
  </h5>
  <!-- Menu -->
  <div class="text-right w-1/2 p-2">
    <button
      type="button"
      on:click={scrollToRegisterInterest}
      class="bg-japanese-900 text-gray-50 px-3 py-2 rounded-3xl text-md hover:bg-boyblue-900 hidden lg:inline"
      >Now Available</button
    >
  </div>
</nav>
<!--hero section-->
<section id="hero">
  <div
    class="flex flex-col bg-gradient-to-r from-purple-500 to-purple-900 text-center 
    items-center bg-repeat bg-opacity-700 bg-center"
  >
    <h1 class="text-2xl lg:text-4xl p-5 lg:text-4xl font-black text-gray-50 pb-15">
      Your Personal <br /> Gut & Digestive Health Companion
    </h1>
    
    <!-- svelte-ignore a11y-img-redundant-alt -->
    <img
      src="../images/logmypoop/log-my-poop-hero-image.png"
      alt="log my poop hero image"
      class="-mb-52"
    />
  </div>
  <div
  class="flex flex-wrap justify-center bg-palepink-400  text-center pt-60 md:gap-x-14"
>
  <a href="https://www.producthunt.com/posts/logmypoop-app?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-logmypoop&#0045;app" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=376683&theme=light" alt="LogMyPoop&#0032;App - Bowel&#0032;health&#0032;tracking&#0032;free&#0032;app | Product Hunt" style="width: 250px; height: 54px;" width="250" height="54" /></a>
  </div>
  <div
    class="flex flex-wrap justify-center bg-palepink-400  text-center pt-10 md:gap-x-14"
  >
  <a title="Download LogMyPoop Now on Apple AppStore and support your digestive health and gut health today" style="cursor:hand" href="https://apps.apple.com/us/app/logmypoop/id1660018292?ign-itscg=30200">
    <img
      src="../images/logmypoop/log_my_poop_available_app_store.png"
      alt="logmypoop available now apple at app store"
      class="p-4"
    />
  </a>
  <a title="Download LogMyPoop Now on Play Store and support your digestive health and gut health today" style="cursor:hand" href="https://play.google.com/store/apps/details?id=com.squaredojo.logmypoop">
    <img
      src="../images/logmypoop/log_my_poop_available_play_store.png"
      alt="logmypoop available now apple at play store"
      class="p-4"
    />
  </a>
   
  </div>
</section>
<section id="what_can_it_do" class="bg-palepink-400 pt-20">
  <div class="text-center">
    <span class="text-purple-700 font-bold mb-10 text-3xl md:text-4xl">Pro Benefits For Free</span>
  </div>
  <div class="mb-20">
    <svg
      class="w-10 h-10 mx-auto animate-bounce"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
      />
    </svg>
  </div>
  <FeatureTypeOne
    text="Poops come in all different sizes and shapes and sometimes none. We have
  included all the standard scientific metrics in the app that can be
  linked to a bowel movement. No more forgetting when did you go and how
  exactly was it ? Our easy UI can enable you to record your poop within
  seconds."
    title="Tracks Digestive Health"
    imgsrc="../images/logmypoop/log_my_poop_phone_calendar.png"
    reverse={false}
  />

  <FeatureTypeOne
    text="Analyses your daily habits that can impact your gut health and contribute to digestive wellness. You will get to
  know how habits like drinking, consuming unhealthy food or exercising impacted
  your gut health. Knowing symptoms and habits relationship works towards overall intestinal and gut health and enhance digestive wellness"
    title="Symptoms Vs Habits"
    imgsrc="../images/logmypoop/log_my_poop_phone_log.png"
    reverse={true}
  />

  <FeatureTypeOne
    text="It is more common than not to take some 
                  medicine like a laxative for constipation relief or irritable bowel syndrome. You can now add medicines of 
                  different shapes and sizes within the app 
                  and link them to your poop."
    title="Record Medicine Usage"
    imgsrc="../images/logmypoop/log_my_poop_phone_medicines.png"
    reverse={false}
  />

  <FeatureTypeOne
    text="Do you need track digestive health for baby or an elderly in your family ? 
                        You will be able add profiles for all 
                        family members and keep a note 
                        of their digestive wellness within the app."
    title="Complete Family"
    imgsrc="../images/logmypoop/log_my_poop_phone_profiles.png"
    reverse={true}
  />

  <FeatureTypeOne
    text="The app works with the theme setting of your phone. The night mode makes it easier to log at late night without straining your eyes."
    title="For Late Night"
    imgsrc="../images/logmypoop/log_my_poop_phone_dark.png"
    reverse={false}
  />

  <FeatureTypeOne
    text="Know when and how many times in week 
                  or month or year did you poop. How many medicines you taken 
                  and how your habits have been impacting your symptoms in long run towards your gut or digestive health. Reports provides synposis of any underlying digestive conditions like constipation or IBS."
    title="Built-In Intelligence"
    imgsrc="../images/logmypoop/log_my_poop_phone_reports.png"
    reverse={true}
  />

  <FeatureTypeOne
    text="Lost your phone or just changing from ios to android or vice versa ? We got you covered. 
                  The app can backup all your digestive health records and restore it in time of need all for free.
                  Our chosen backup platform is Dropbox which is both free and platform independent. 
                  No need to start over or panic and spoil your digestive wellness."
    title="Never lose your data"
    imgsrc="../images/logmypoop/log_my_poop_phone_export.png"
    reverse={false}
  />
</section>
<section
  id="register_interest"
  class="flex flex-col  text-center items-center bg-purple-50 py-10 "
>
<div class="text-center">
  <span class="text-purple-700 font-bold mb-10 text-3xl md:text-4xl">Next Release</span>
</div>
  <p class="text-xl opacity-70 max-w-xl p-2">
    Enter your email address and be the first one to know when we are ready to publish new features
  </p>
  <form
    id="form_logmypoop_notify"
    name="logmypoop_register"
    action="#"
    data-netlify-honeypot="bot-field"
    data-netlify="true"
  >
    <div class="flex flex-row justify-center">   
      <div class="flex flex-row justify-center">
        <input
        type="email"
        id="email_address"
        name="email_address" 
        placeholder="Your email address"
        class="px-2 py-4 text-lg md:pr-36 bg-gray-100 rounded-md border border-gray-400 
        text-purple-700
        w-2/3
        focus:outline-none"
        required
      />
      <button
        on:click={handleSubmit}
        type="submit"
        class=" bg-purple-600 text-md md:text-lg  text-white px-6 mx-1 rounded-md shadow hover:bg-boyblue-900 hover:animate-wiggle"
        >Notify Me</button
      >
      <input type="hidden" name="form-name" value="logmypoop_register" />
      </div>
     
    </div>
  </form>
</section>
<section
  id="download_app"
  class="flex  flex-col  text-center items-center bg-sand-900 py-10"
>
<div class="text-center">
  <span class="text-purple-700 font-bold mb-10 text-3xl md:text-4xl">Download App</span>
</div>
  <p class="text-xl opacity-70 max-w-xl">
    Ability to take pictures of poop, integrated calendar, smart reports and simple to use UI that
    enables log poop within seconds for a better digestive health. All that for free. No IAP.
  </p>
  <div class="flex flex-wrap justify-center p-8 md:gap-x-14">
    <a title="Download LogMyPoop Now on Apple AppStore" style="cursor:hand" href="https://apps.apple.com/us/app/logmypoop/id1660018292?ign-itscg=30200">
      <img
        src="../images/logmypoop/log_my_poop_available_app_store.png"
        alt="logmypoop available now apple at app store"
        class="p-4"
      />
    </a>
    <a title="Download LogMyPoop Now on Play Store" style="cursor:hand" href="https://play.google.com/store/apps/details?id=com.squaredojo.logmypoop">
      <img
        src="../images/logmypoop/log_my_poop_available_play_store.png"
        alt="logmypoop available now apple at play store"
        class="p-4"
      />
    </a>
  </div>
</section>
<section
  id="feedback"
  class="flex flex-col  text-center items-center bg-pink-50 py-10 "
>
<div class="text-center">
  <span class="text-purple-700 font-bold mb-10 text-3xl md:text-4xl">Feedback Form</span>
</div>
  <p class="text-xl opacity-70 max-w-xl p-2">
    Are you user of Log My Poop already ? Please use the form below to provide us feedback. We will use your feedback to bring improvements in the app and offer better digestive wellness.
  </p>
  <form
    id="form_logmypoop_feedback"
    name="logmypoop_feedback"
    action="#"
    data-netlify-honeypot="bot-field"
    data-netlify="true"
  >
    <div class="flex flex-row justify-center  text-center">   
      <div class="flex flex-col justify-center">
        <input
        type="email"
        id="feedback_email_address"
        name="feedback_email_address" 
        placeholder="Your email address"
        class="px-2 py-4 text-lg md:pr-36 bg-gray-100 rounded-md border border-gray-400 
        text-purple-700
        focus:outline-none"
        required
      />
      
      <select id="commenttype" name="commenttype" placeholder="Select Your Experience" class="form-select appearance-none px-2 py-4 mt-5 text-lg md:pr-36 bg-gray-100 
      rounded-md border border-gray-400 focus:border-teal-500 focus:outline-none">
        <option value="" disabled selected hidden>Type of comment...</option>
        <option value="Praise">Praise our work</option>
        <option value="Suggestion">Suggestion for Improvement</option>
        <option value="Complaint">Complaint</option>
      </select>
    
      <textarea
      id="comment"
      name="comment" 
      placeholder="Your comment"
      class="px-2 py-4 mt-5 text-lg md:pr-36 bg-gray-100 rounded-md border border-gray-400 
      text-purple-700
      focus:outline-none"
      required
    />
    <input type="hidden" name="form-name" value="logmypoop_feedback" />
    <div class="flex flex-col justify-center items-center">
      <button
        on:click={handleFeedbackSubmit}
        type="submit"
        class=" bg-purple-600 w-1/2   py-4 px-2 mt-5 text-md md:text-lg  text-white  mx-1 rounded-md shadow hover:bg-boyblue-900 
        hover:animate-wiggle"
        >Submit</button
      >
      </div>
      </div>
    </div>
  </form>
</section>
<footer class="bg-purple-900  -mb-12">
  <div class="container flex flex-row  mx-auto pt-10 justify-around">
    <div class="-mt-20 md:-mt-32">
      <img
        src="../images/logmypoop/success.png"
        alt="log my poop coming soon"
      />
    </div>
    <div class="flex flex-col">
      <h5 class="text-gray-50">FOLLOW</h5>
      <a
        href="https://twitter.com/squaredojo"
        target="_blank"
        class="no-underline text-gray-400 text-lg py-4 hover:underline"
        >Twitter</a
      >
      <a
        href="https://www.instagram.com/squaredojo/"
        target="_blank"
        class="no-underline text-gray-400 text-lg  py-4 hover:underline"
        >Instagram</a
      >
    </div>
    <div class="flex flex-col invisible md:visible">
      <h5 class="text-gray-50">HELP</h5>
      <a
        href="#"
        class="no-underline text-gray-400 text-lg  py-4 hover:underline">FAQ</a
      >
      <a
        href="#"
        class="no-underline text-gray-400 text-lg  py-4 hover:underline"
        >Contact</a
      >
    </div>
    <div class="flex flex-col pr-2 -ml-10">
      <h5 class="text-gray-50">ABOUT</h5>
      <a
        href="#"
        class="no-underline text-gray-400 text-lg  py-4 hover:underline"
        >Squaredojo</a
      >
      <a
        href="#/LogMyPoop/Privacy"
        class="no-underline text-gray-400 text-lg  py-4 hover:underline"
        >Privacy</a
      >
    </div>
    <div>
      <button
        on:click={scrollToTop}
        type="button"
        data-mdb-ripple="true"
        data-mdb-ripple-color="light"
        class="inline-block p-3 bg-japanese-200 text-white font-medium text-xs rounded-full shadow-md hover:bg-japanese-600 hover:shadow-lg focus:bg-japanese-900 focus:shadow-lg 
      focus:outline-none focus:ring-0 active:bg-japanese-900 active:shadow-lg transition duration-150 ease-in-out  bottom-5 right-5 fixed z-10"
        id="btn-back-to-top"
      >
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          class="w-4 h-4"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="currentColor"
            d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
          />
        </svg>
      </button>
    </div>
  </div>
  <div class="container mx-auto text-center text-gray-400 p-5 opacity-50">
    2023 | Made with ❤ by <a href="#">SquareDojo</a>
  </div>
</footer>
